import { faL, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useCallback, useEffect, useState } from 'react'
import { PLATFORM_FIELD, platformfielddata_set } from 'src/interfaces/Platform.interface'
import { MAPPING_ITEM_OF_RECIPE_DATA, PRODUCT_RECIPE, RECIPE, RECIPE_FORM_DATA } from 'src/interfaces/Template.interface'
import Select, { components, MenuListProps } from 'react-select'
import { FormikState } from 'formik'
import { deleteRecipeMappingItemAsync, getPlatformChildFieldDataCategoriesAsync, getPlatformParentFieldDataCategoriesAsync, getPlatformParentFieldDataWhenPlatformIsCategorySelectedAsync } from 'src/redux/actions/templateAndPricingActions'
import { useAppDispatch } from 'src/redux/storeHooks'
import useAppToast from 'src/hooks/useAppToast'
import { usePermission } from 'src/hooks/usePermission'

type RecipeRuleItemPropsType = {
  formValues: RECIPE_FORM_DATA
  handleChange: (ev: React.ChangeEvent) => void
  customFieldLoading: boolean
  recipe: PRODUCT_RECIPE
  recipeIndex: number
  setFormikState: (
    f:
      | FormikState<RECIPE_FORM_DATA>
      | ((prevState: FormikState<RECIPE_FORM_DATA>) => FormikState<RECIPE_FORM_DATA>),
    cb?: (() => void) | undefined
  ) => void
  setSubmitting: (isSubmitting: boolean) => void
  getLatestRecipesList: () => void
  recipeData: RECIPE | null
  platformNativeFields: PLATFORM_FIELD[] | []
  platformCustomFields: PLATFORM_FIELD[] | []
  recipeDataInDetail: MAPPING_ITEM_OF_RECIPE_DATA | null
  selectedRowsForDeletion: (number | null)[]; // The array of IDs marked for deletion
  setSelectedRowsForDeletion: React.Dispatch<React.SetStateAction<(number | null)[]>>; // The setter for that array
  checkFormField?: string;
  isQuickTab?: boolean;
  hideConditionOnSingleRow?: boolean;
}

const RecipeRuleItem: FC<RecipeRuleItemPropsType> = ({
  formValues,
  handleChange,
  customFieldLoading,
  recipe,
  recipeIndex,
  setFormikState,
  setSubmitting,
  getLatestRecipesList,
  platformCustomFields,
  platformNativeFields,
  recipeData,
  recipeDataInDetail,
  selectedRowsForDeletion,
  setSelectedRowsForDeletion,
  checkFormField,
  isQuickTab,
  hideConditionOnSingleRow = false,
}) => {
    const {isRead, isWrite, isDelete} = usePermission();

  //   const [platformNativeFields, setPlatformNativeFields] = useState<PLATFORM_FIELD[] | []>([])
  //   const [platformCustomFields, setPlatformCustomFields] = useState<PLATFORM_FIELD[] | []>([])
  const [platformFiledDataSet, setPlatformFiledDataSet] = useState<platformfielddata_set[] | []>([])
  const [checkedPlatformField, setCheckedPlatformField] = useState<null | number>(null)
  const [platformFieldDataSetLoading, setPlatformFieldDataSetLoading] = useState<boolean>(false)
  const dispatch = useAppDispatch()
  const { errorToast, successToast, warningToast } = useAppToast()

  //this is use when we select category field 
  const [isCategoryFieldSelected, setIsCategoryFieldSelected] = useState(false)
  const [noChildrenFound, setNoChildrenFound] = useState(false)
  const [lastAccessedParent, setLastAccessedParent] = useState([{ label: 'Select Sub category', value: '' }])

  const getPlatformDataSetAsync = useCallback(
    (platformFieldId) => {
      setPlatformFieldDataSetLoading(true)
      dispatch(getPlatformParentFieldDataCategoriesAsync({ platform_Id: platformFieldId }))
        .then((response) => {
          if (response.payload?.length) {
            setPlatformFiledDataSet(response.payload)
            setPlatformFieldDataSetLoading(false)
          }
          setPlatformFieldDataSetLoading(false)
        })
        .catch(() => {
          setPlatformFieldDataSetLoading(false)
        })
    },
    [],
  )

  const getPlatformChildFieldDataAsync = (platformFieldId, fieldmeta = { label: '', value: '' }, isBack = false, isParentDataNull = false) => {
    setPlatformFieldDataSetLoading(true)
    dispatch(getPlatformChildFieldDataCategoriesAsync({ platform_Id: platformFieldId }))
      .then((response) => {
        if (response.payload?.length) {
          setPlatformFiledDataSet(response.payload)
          if (isBack) {
            let shadow = [...lastAccessedParent]
            shadow.pop()
            setLastAccessedParent(shadow)
          } else {
            setLastAccessedParent((pre) => {
              return [...pre, fieldmeta]
            })
          }
          setPlatformFieldDataSetLoading(false)
        } else {
          if (!isParentDataNull) {
            setNoChildrenFound(true)
          } else {
            setNoChildrenFound(true)
          }
        }
        setPlatformFieldDataSetLoading(false)
      })
      .catch(() => {
        setPlatformFieldDataSetLoading(false)
      })
  }


  useEffect(() => {
    const loadInitialData = async () => {
      if (!recipe.id || !recipeDataInDetail) return;
      const field = recipeDataInDetail.check_platform_field;
      const isCategoryField = field.api_code === "CATEGORY";
      const isSelectField =
        field.input_type === "SELECT" || field.input_type === "MULTISELECT";

      // TEXT / FLOAT / INTEGER rows do not need option prefetch — skip to avoid
      // leaving the field dropdown stuck in a disabled loading state.
      if (!isCategoryField && !isSelectField) return;

      try {
        if (isSelectField && !isCategoryField) {
          setPlatformFieldDataSetLoading(true);
          const parentRes = await dispatch(
            getPlatformParentFieldDataCategoriesAsync({
              platform_Id: field.id,
            })
          );
          if (parentRes.payload?.length) {
            setPlatformFiledDataSet(parentRes.payload);
          }
          return;
        }

        // CASE : PRE-FILL CATEGORY (with parent → child chain)
        if (isCategoryField) {
          setPlatformFieldDataSetLoading(true);
          setIsCategoryFieldSelected(true);
          const selectedCategoryIds = recipeDataInDetail.check_value.split(",");
          const firstSelected = selectedCategoryIds[0];
          if (!firstSelected) return;

          // Get PARENT for this selected subcategory
          const parentRes = await dispatch(
            getPlatformParentFieldDataWhenPlatformIsCategorySelectedAsync({
              subCategory_id: firstSelected,
            })
          );
          if (!parentRes.payload?.length) {
            return;
          }
          if (parentRes.payload?.length === 1 && parentRes.payload.length <= 1) {
            const parentRes = await dispatch(
              getPlatformParentFieldDataCategoriesAsync({
                platform_Id: field.id,
              })
            );
            if (parentRes.payload?.length) {
              setPlatformFiledDataSet(parentRes.payload);
            }
            return;
          } else {
            let parentId = parentRes.payload[0]?.id;
            if (parentRes.payload.length > 1) {
              const lengthData = parentRes.payload.length - 2;
              parentId = parentRes.payload[lengthData]?.id;
            }
            if (!parentId) {
              return;
            }

            //  Get CHILDREN of that parent
            const childRes = await dispatch(
              getPlatformChildFieldDataCategoriesAsync({
                platform_Id: Number(parentId),
              })
            );
            if (childRes.payload?.length) {
              setPlatformFiledDataSet(childRes.payload);
              //  Update "back navigation" path
              const last = parentRes.payload[parentRes.payload.length - 2];
              setLastAccessedParent([
                { label: "Select Category", value: "" },
                {
                  label: last?.api_name,
                  value: last?.platform_field,
                },
              ]);
            }
          }
        }
      } catch (error) {
        console.log("Category Prefill Error:", error);
        setIsCategoryFieldSelected(false);
      } finally {
        setPlatformFieldDataSetLoading(false);
      }
    };

    loadInitialData();
  }, [recipeDataInDetail]);
  useEffect(() => {
    return () => {
      setSelectedRowsForDeletion([])
    }
  }, [])

  const selectedFieldMeta = [...platformNativeFields, ...platformCustomFields].find(
    (pltFrm) => pltFrm.id + '' === ((isQuickTab && formValues.productRecipes[recipeIndex].checkPlatformField === '') ?
      checkFormField : formValues.productRecipes[recipeIndex].checkPlatformField))

  const normalizeFieldName = (name: string | undefined | null) =>
    (name ?? '').toLowerCase().replace(/\s+/g, ' ').trim()
  const normalizedDisplayName = normalizeFieldName(selectedFieldMeta?.display_name)
  const normalizedApiName = normalizeFieldName(selectedFieldMeta?.api_name)
  const normalizedApiCode = normalizeFieldName(selectedFieldMeta?.api_code)
  const selectedFieldIdString = selectedFieldMeta?.id ? String(selectedFieldMeta.id) : ''
  const isTagsField =
    normalizedDisplayName === 'tags' ||
    normalizedApiName === 'tags' ||
    normalizedApiCode === 'tags'
  const allowEqualityOperators = selectedFieldIdString
    ? isTagsField || !['2079', '1370'].includes(selectedFieldIdString)
    : true
  const priceFieldNames = new Set(['price', 'compare price'])
  const weightFieldNames = new Set([
    'weight (in grams)',
    'weight (in kg)',
    'weight (in ounces)',
    'weight (same as source)',
  ])
  const costFieldNames = new Set(['cost per item'])
  const isPriceField = priceFieldNames.has(normalizedDisplayName)
  const isWeightField = weightFieldNames.has(normalizedDisplayName)
  const isCostField = costFieldNames.has(normalizedDisplayName)
  const isIntegerField = selectedFieldMeta?.input_type === 'INTEGER'
  const isNumericComparableField = isPriceField || isWeightField || isCostField
  const isQuantityField =
    normalizedApiName === 'quantity' || normalizedApiCode === 'quantity'
  const requiresNumericInput = isNumericComparableField || isQuantityField || isIntegerField

  let textOperatorOptions: { value: string; label: string }[]
  if (isQuantityField) {
    textOperatorOptions = [
      { value: 'GREATER_THAN', label: 'Greater than' },
      { value: 'SMALLER_THAN', label: 'Smaller than' },
    ]
  } else {
    textOperatorOptions = [
      { value: 'CONTAINS', label: 'Contain' },
      { value: 'NOT_CONTAINS', label: 'Does not Contain' },
    ]
    if (allowEqualityOperators) {
      textOperatorOptions.push(
        { value: 'EQUAL', label: 'Equals to' },
        { value: 'NOT_EQUAL', label: 'Not Equals' }
      )
    }
    if (isNumericComparableField) {
      textOperatorOptions.push(
        { value: 'GREATER_THAN', label: 'Greater than' },
        { value: 'SMALLER_THAN', label: 'Smaller than' }
      )
    }
  }

  let floatOperatorOptions: { value: string; label: string }[]
  if (isQuantityField) {
    floatOperatorOptions = [
      { value: 'GREATER_THAN', label: 'Greater than' },
      { value: 'SMALLER_THAN', label: 'Smaller than' },
    ]
  } else if (isNumericComparableField || isIntegerField) {
    floatOperatorOptions = [
      { value: 'EQUAL', label: 'Equals To' },
      { value: 'GREATER_THAN', label: 'Greater than' },
      { value: 'SMALLER_THAN', label: 'Smaller than' },
    ]
  } else {
    floatOperatorOptions = [
      { value: 'EQUAL', label: 'Equals To' },
      { value: 'CONTAINS', label: 'Contain' },
      { value: 'GREATER', label: 'Greater Than' },
      { value: 'SMALLER', label: 'Less Than' },
    ]
  }

  if (
    !isQuantityField &&
    !textOperatorOptions.find((opt) => opt.value === recipe.checkOperator)
  ) {
    textOperatorOptions.push({ value: recipe.checkOperator, label: recipe.checkOperator })
  }

  if (
    !isQuantityField &&
    !floatOperatorOptions.find((opt) => opt.value === recipe.checkOperator)
  ) {
    floatOperatorOptions.push({ value: recipe.checkOperator, label: recipe.checkOperator })
  }

  const selectableOperatorOptions = [
    { value: 'CONTAINS', label: 'Contain' },
    { value: 'NOT_CONTAINS', label: 'Does not Contain' },
    ...(allowEqualityOperators
      ? [
          { value: 'EQUAL', label: 'Equals to' },
          { value: 'NOT_EQUAL', label: 'Not Equals' },
        ]
      : []),
  ]

  const operatorValue = isQuantityField
    ? recipe.checkOperator === 'SMALLER_THAN'
      ? 'SMALLER_THAN'
      : 'GREATER_THAN'
    : recipe.checkOperator

  useEffect(() => {
    if (!isQuantityField || recipe.checkOperator === operatorValue) {
      return
    }

    setFormikState((prevState) => {
      const productRecipes = [...prevState.values.productRecipes]
      productRecipes[recipeIndex] = {
        ...productRecipes[recipeIndex],
        checkOperator: operatorValue,
      }

      return {
        ...prevState,
        values: {
          ...prevState.values,
          productRecipes,
        },
      }
    })
  }, [isQuantityField, operatorValue, recipe.checkOperator, recipeIndex, setFormikState])

  const showConditionSelector = !(hideConditionOnSingleRow && formValues.productRecipes.length <= 1)
  const isCategoryApiField = selectedFieldMeta?.api_code === 'CATEGORY'
  const useCategoryTreePicker = isCategoryApiField || isCategoryFieldSelected
  const showSelectStyleEvaluator =
    selectedFieldMeta?.input_type === 'SELECT' ||
    (selectedFieldMeta?.input_type === 'MULTISELECT' && isCategoryApiField)
  const showFlatMultiSelectEvaluator =
    selectedFieldMeta?.input_type === 'MULTISELECT' && !isCategoryApiField

  return (
    <div className='row g-3 gx-lg-3 align-items-center'  style={{ marginTop: isQuickTab ? "0px" : undefined }}>
      <div className={showConditionSelector ? 'col-6 col-sm-2' : 'd-none'}>
        {showConditionSelector &&
          !(recipe.id !== undefined && selectedRowsForDeletion.includes(recipe.id)) &&
          (recipeIndex === 0 || recipeIndex !== formValues.productRecipes.length - 1) && (
            <select
              className='form-select'
              style={{ height: 32 }}
              name={`dataConjunction`}
              value={formValues.dataConjunction}
              onChange={handleChange}
            >
              <option value='AND'>And</option>
              <option value='OR'>Or</option>
            </select>
          )}
      </div>
      {!(recipe.id !== undefined && selectedRowsForDeletion.includes(recipe.id)) &&
        <div className='col-6 col-sm-3'>
          <select
            className='form-select'
            style={{ height: 32 }}
            disabled={platformFieldDataSetLoading}
            onChange={(ev) => {
              if (ev.target.value) {
                let matchedForInputTypeSelect = [...platformCustomFields, ...platformNativeFields].find((item) => (item.id == Number(ev.target.value)))
                if (matchedForInputTypeSelect?.api_code === 'CATEGORY') {
                  setIsCategoryFieldSelected(true)
                  setNoChildrenFound(false)
                  setLastAccessedParent([{ label: 'Select Sub category', value: '' }])
                } else {
                  setIsCategoryFieldSelected(false)
                  setNoChildrenFound(false)
                  setLastAccessedParent([{ label: 'Select Sub category', value: '' }])
                }
                if (matchedForInputTypeSelect?.input_type == 'SELECT' || matchedForInputTypeSelect?.input_type == 'MULTISELECT') {
                  // setCheckedPlatformField(Number(ev.target.value))
                  getPlatformDataSetAsync(ev.target.value)
                }
              }
              handleChange(ev)
            }}
            value={recipe.checkPlatformField}
            name={`productRecipes[${recipeIndex}].checkPlatformField`}
          >
            <optgroup label='Native Fields'>
              {platformNativeFields.length &&
                [...platformNativeFields].map((item: PLATFORM_FIELD) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item.display_name}
                    </option>
                  )
                })}
            </optgroup>
            <optgroup label='Custom Fields'>
              {platformCustomFields.length &&
                [...platformCustomFields].map((item: PLATFORM_FIELD) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item.display_name}
                    </option>
                  )
                })}
            </optgroup>
          </select>
        </div>}

      {!(recipe.id !== undefined && selectedRowsForDeletion.includes(recipe.id)) &&
        selectedFieldMeta?.input_type == 'TEXT' && (
          <div className='col-12 col-lg-6'>
            <div className='d-flex gap-2 align-items-center flex-nowrap'>
              <div className='flex-grow-1 flex-lg-grow-0' style={{ minWidth: '140px' }}>
                <select
                  className='form-select'
                  style={{ height: 32 }}
                  name={`productRecipes[${recipeIndex}].checkOperator`}
                  value={operatorValue}
                  onChange={handleChange}
                >
                  {textOperatorOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <input
                type={requiresNumericInput ? 'number' : 'text'}
                inputMode={requiresNumericInput ? 'decimal' : 'text'}
                step={requiresNumericInput ? 'any' : undefined}
                required
                className='form-control flex-grow-1 flex-lg-grow-0'
                style={{ minWidth: '200px', maxWidth: '320px' }}
                placeholder='Enter a value'
                value={recipe.checkValue}
                name={`productRecipes[${recipeIndex}].checkValue`}
                onChange={(ev) => {
                  if (requiresNumericInput) {
                    const value = ev.target.value
                    if (value === '' || /^\d*(\.\d*)?$/.test(value)) {
                      handleChange(ev)
                    }
                    return
                  }
                  handleChange(ev)
                }}
              />
            </div>
          </div>
        )}

      {!(recipe.id !== undefined && selectedRowsForDeletion.includes(recipe.id)) &&
        (selectedFieldMeta?.input_type == 'FLOAT' || selectedFieldMeta?.input_type == 'INTEGER') && (
          <div className='col-12 col-lg-6'>
            <div className='d-flex gap-2 align-items-center flex-nowrap'>
              <div className='flex-grow-1 flex-lg-grow-0' style={{ minWidth: '160px' }}>
                <select
                  className='form-select'
                  style={{ height: 32 }}
                  name={`productRecipes[${recipeIndex}].checkOperator`}
                  value={operatorValue}
                  onChange={handleChange}
                >
                  {floatOperatorOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <input
                type={requiresNumericInput ? 'number' : 'text'}
                inputMode={requiresNumericInput ? 'decimal' : 'text'}
                step={requiresNumericInput ? 'any' : undefined}
                required
                placeholder='Enter a value'
                className='form-control flex-grow-1 flex-lg-grow-0'
                style={{ minWidth: '200px', maxWidth: '320px' }}
                value={recipe.checkValue}
                name={`productRecipes[${recipeIndex}].checkValue`}
                onChange={(ev) => {
                  if (requiresNumericInput) {
                    const value = ev.target.value
                    if (value === '' || /^\d*(\.\d*)?$/.test(value)) {
                      handleChange(ev)
                    }
                    return
                  }
                  handleChange(ev)
                }}
              />
            </div>
          </div>
        )}

      {!(recipe.id !== undefined && selectedRowsForDeletion.includes(recipe.id)) &&
        showSelectStyleEvaluator && (
          <div className='col-12 col-lg-6'>
            <div className='row g-2 align-items-center'>
              <div className='col-12 col-lg-3'>
                <select
                  className='form-select'
                  style={{ height: 32 }}
                  name={`productRecipes[${recipeIndex}].checkOperator`}
                  value={recipe.checkOperator}
                  onChange={handleChange}
                >
                  {selectableOperatorOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-12 col-lg-3'>
                <select
                  className='form-select'
                  style={{ height: 32 }}
                  name={`productRecipes[${recipeIndex}].checkConjunction`}
                  value={recipe.checkConjunction}
                  onChange={handleChange}
                >
                  <option value='OR'>Any</option>
                  <option value='AND'>All</option>
                </select>
              </div>
              <div className='col-12 col-lg-6'>
                {!useCategoryTreePicker ?

                  <Select
                    isMulti
                    isClearable={true}
                    isLoading={platformFieldDataSetLoading}
                    key={'selc' + recipeIndex + platformFiledDataSet.length}
                    hideSelectedOptions
                    required
                    placeholder={`Select your collection`}
                    options={platformFiledDataSet.map((pltd) => ({
                      label: pltd.api_name,
                      value: pltd.id + '',
                    }))}
                    value={
                      recipe.checkValue.length
                        ? recipe.checkValue.split(',').map((selc, ins) => {

                          if (!isNaN(Number(selc))) {
                            return {
                              label: platformFiledDataSet.find((pltd) => pltd.id + '' == selc)?.api_name,
                              value: selc,
                            }
                          }
                        })
                        : []
                    }
                    onChange={(newValues, actionMeta) => {

                      let updats: string[] = newValues.map((it) => {
                        return it!.value
                      })
                      let fullary = [...formValues.productRecipes]
                      let modifyingRecipe = recipe
                      modifyingRecipe.checkValue = updats.join(',')
                      fullary[recipeIndex] = modifyingRecipe

                      setFormikState((pre) => {
                        return {
                          ...pre,
                          values: {
                            ...pre.values,
                            productRecipes: [...fullary],
                          },
                        }
                      })
                    }}
                  />
                  :
                  <div>
                    <Select
                      isMulti
                      isClearable={true}
                      required
                      defaultMenuIsOpen={recipe.id ? false : true}
                      isLoading={platformFieldDataSetLoading}
                      key={'selc' + recipeIndex + platformFiledDataSet.length}
                      hideSelectedOptions
                      placeholder={`Select your Category`}
                      options={platformFiledDataSet.map((pltd) => ({
                        label: pltd.api_name,
                        value: pltd.id + '',
                      }))}
                      value={
                        recipe.checkValue.length
                          ? recipe.checkValue.split(',').map((selc, ins) => {

                            if (!isNaN(Number(selc))) {
                              return {
                                label: platformFiledDataSet.find((pltd) => pltd.id + '' == selc)?.api_name,
                                value: selc,
                              }
                            }
                          })
                          : []
                      }
                      onChange={(newValues, actionMeta) => {

                        let updats: string[] = newValues.map((it) => {
                          return it!.value
                        })
                        let fullary = [...formValues.productRecipes]
                        let modifyingRecipe = recipe
                        modifyingRecipe.checkValue = updats.join(',')
                        fullary[recipeIndex] = modifyingRecipe

                        setFormikState((pre) => {
                          return {
                            ...pre,
                            values: {
                              ...pre.values,
                              productRecipes: [...fullary],
                            },
                          }
                        })
                      }}
                      closeMenuOnSelect={false}
                      components={{
                        // top of menu list
                        MenuList: (props) => {
                          // if nested children not found after select a sub category or category allow user to select value otherwise allow user to nest select subcategory
                          if (noChildrenFound) {
                            return (
                              <components.MenuList {...props} >
                                <button type='button' className='w-100 btn btn-text d-flex justify-content-start align-items-center border-bottom p-2'
                                  onClick={() => {
                                    if (lastAccessedParent[lastAccessedParent.length - 1]['value']) {
                                      if (lastAccessedParent.length > 2) {
                                        getPlatformChildFieldDataAsync(lastAccessedParent[lastAccessedParent.length - 1]['value'], { label: 'Select Category', value: '' }, true)
                                        setNoChildrenFound(false)
                                      } else {
                                        // this part always run when we want top category
                                        getPlatformDataSetAsync(lastAccessedParent[lastAccessedParent.length - 1]['value'])
                                        setLastAccessedParent([{ label: 'Select Category', value: '' }])
                                        setNoChildrenFound(false)
                                      }
                                    }
                                    let fullary = [...formValues.productRecipes]
                                    let modifyingRecipe = recipe
                                    modifyingRecipe.checkValue = ''
                                    fullary[recipeIndex] = modifyingRecipe
                                    setFormikState((pre) => {
                                      return {
                                        ...pre,
                                        values: {
                                          ...pre.values,
                                          productRecipes: [...fullary],
                                        },
                                      }
                                    })

                                  }}
                                >
                                  <i className="bi bi-arrow-left-circle-fill text-primary"></i>
                                  <p className='fs-6 fw-bold mb-0 ms-3' >{lastAccessedParent[lastAccessedParent.length - 1]['label']}</p>
                                </button>
                                <div>
                                  {props.children}
                                </div>
                              </components.MenuList>
                            )
                          } else {
                            return (
                              <div>
                                <button type='button' className='w-100 btn btn-text d-flex justify-content-start align-items-center border-bottom p-2'
                                  onClick={() => {
                                    //this is case when we are under the sub category
                                    if (lastAccessedParent[lastAccessedParent.length - 1]['value']) {
                                      if (lastAccessedParent.length > 2) {
                                        getPlatformChildFieldDataAsync(lastAccessedParent[lastAccessedParent.length - 1]['value'], { label: 'Select Category', value: '' }, true)
                                        setNoChildrenFound(false)
                                      } else {
                                        // this part always run when we want top category
                                        getPlatformDataSetAsync(lastAccessedParent[lastAccessedParent.length - 1]['value'])
                                        setLastAccessedParent([{ label: 'Select Category', value: '' }])
                                        setNoChildrenFound(false)
                                      }
                                    }
                                    let fullary = [...formValues.productRecipes]
                                    let modifyingRecipe = recipe
                                    modifyingRecipe.checkValue = ''
                                    fullary[recipeIndex] = modifyingRecipe
                                    setFormikState((pre) => {
                                      return {
                                        ...pre,
                                        values: {
                                          ...pre.values,
                                          productRecipes: [...fullary],
                                        },
                                      }
                                    })
                                  }}

                                >
                                  <i className="bi bi-arrow-left-circle-fill text-primary"></i>
                                  <p className='fs-6 fw-bold mb-0 ms-3' >{lastAccessedParent[lastAccessedParent.length - 1]['label']}</p>
                                </button>
                                <div className='h-100px overflow-y-scroll' >
                                  <p className='mb-0 fs-4 fw-bold' >{props.children}</p>
                                </div>
                              </div>
                            )
                          }
                        },
                        Option: (props) => {
                          if (noChildrenFound) {
                            return (
                              <div className='p-2  border-bottom' {...props.innerProps} >
                                <p className='fs-5 mb-0' >{props.label}</p>
                              </div>
                            )
                          } else {
                            return (
                              <button type='button' className='btn btn-outline rounded-0 text-start justify-content-between d-flex w-100 fs-5 align-items-center' onClick={() => {

                                // in subcategory the have parent_data but in case of top category they not have parent_data and calling api is different
                                // we are setting last accessed parent with second params
                                if (platformFiledDataSet[0]['parent_data'] === null) {
                                  getPlatformChildFieldDataAsync(props['value'], { label: props.label, value: platformFiledDataSet[0]['platform_field'] + '' }, false, true)
                                } else {
                                  getPlatformChildFieldDataAsync(props['value'], { label: props.label, value: platformFiledDataSet[0]['parent_data'] })
                                }
                              }}  >
                                {props.label} <i className="bi bi-arrow-right-square-fill text-primary"></i>
                              </button>
                            )
                          }
                        }
                      }}
                    />
                  </div>

                }
              </div>
            </div>
          </div>
        )}

      {!(recipe.id !== undefined && selectedRowsForDeletion.includes(recipe.id)) &&
        showFlatMultiSelectEvaluator && (
          <div className='col-12 col-lg-6'>
            <div className='row g-2 align-items-center'>
              <div className='col-12 col-lg-3'>
                <select
                  className='form-select'
                  style={{ height: 32 }}
                  name={`productRecipes[${recipeIndex}].checkOperator`}
                  value={recipe.checkOperator}
                  onChange={handleChange}
                >
                  {selectableOperatorOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className='col-12 col-lg-3'>
                <select
                  className='form-select'
                  style={{ height: 32 }}
                  name={`productRecipes[${recipeIndex}].checkConjunction`}
                  value={recipe.checkConjunction}
                  onChange={handleChange}
                >
                  <option value='OR'>Any</option>
                  <option value='AND'>All</option>
                </select>
              </div>
              <div className='col-12 col-lg-6'>
                <Select
                  isMulti
                  isClearable={true}
                  required
                  isLoading={platformFieldDataSetLoading}
                  key={'selc' + recipeIndex + platformFiledDataSet.length}
                  hideSelectedOptions
                  placeholder={`Select your collection`}
                  options={platformFiledDataSet.map((pltd) => ({
                    label: pltd.api_name,
                    value: pltd.id + '',
                  }))}
                  value={
                    recipe.checkValue.length
                      ? recipe.checkValue.split(',').map((selc, ins) => {

                        if (!isNaN(Number(selc))) {
                          return {
                            label: platformFiledDataSet.find((pltd) => pltd.id + '' == selc)?.api_name,
                            value: selc,
                          }
                        }
                      })
                      : []
                  }
                  onChange={(newValues, actionMeta) => {

                    let updats: string[] = (newValues ?? []).map((it) => {
                      return it!.value
                    })
                    let fullary = [...formValues.productRecipes]
                    let modifyingRecipe = recipe
                    modifyingRecipe.checkValue = updats.join(',')
                    fullary[recipeIndex] = modifyingRecipe

                    setFormikState((pre) => {
                      return {
                        ...pre,
                        values: {
                          ...pre.values,
                          productRecipes: [...fullary],
                        },
                      }
                    })
                  }}
                />
              </div>
            </div>
          </div>
        )}
      {(isDelete &&
        formValues.productRecipes.filter((r) => !selectedRowsForDeletion.includes(r.id)).length > 1 &&
        !(recipe.id !== undefined && selectedRowsForDeletion.includes(recipe.id))) &&
        <div className='col-12 col-lg-1 d-flex align-items-center'>
          <button
            className={`btn btn-outline ${recipe.id !== undefined && selectedRowsForDeletion.includes(recipe.id) ? 'btn-light-warning' : 'btn-light-danger'}`}
            type='button'
            onClick={() => {
              if (recipe.id) {
                if (selectedRowsForDeletion.includes(recipe.id)) {
                  // If already selected for deletion, deselect it
                  setSelectedRowsForDeletion((prev) => prev.filter((id) => id !== recipe.id));
                } else {
                  // Otherwise, select for deletion
                  setSelectedRowsForDeletion((prev) => [...prev, recipe.id!]);
                }
              } else {
                // Existing logic for new recipes (without an ID yet)
                const copiedArray = [...formValues.productRecipes];
                const filteredItems = copiedArray.filter(
                  (_, existingRecipeIndex) => existingRecipeIndex !== recipeIndex
                );
                setFormikState((pre: FormikState<RECIPE_FORM_DATA>) => ({
                  ...pre,
                  values: {
                    ...pre.values,
                    productRecipes: [...filteredItems],
                  },
                }));
              }
            }}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>}
    </div>
  )
}

export default RecipeRuleItem

